import React from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';




const  ContractDatatable = (props) => {

   const [t] = useTranslation();      
   const tableName = t('partner.label.contracts');
   const columns = [       
            { name: "Id", data: "id", selector: "id", omit: true},
            { name: t('partner.label.contract'), data: "name", sortable: true, selector: "name"},    		
            { name: t('partner.label.price'), data: "price", sortable: true, selector: "price"},    		
            { name: t('partner.label.validFrom'), data: "validFrom",  sortable: true,  selector: "validFrom"},
            { name: t('partner.label.validTo'), data: "validTo", sortable: true,  selector: "validTo"},
            { name: t('general.label.description'), data: "description", sortable: true,  selector: "description"}            
        ];        


        
    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('partner.label.contract'), data: "name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
        { name: t('partner.label.price'), data: "price", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('partner.label.validFrom'), data: "validFrom", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('partner.label.validTo'), data: "validTo", orderable: true,  searchable: true, search: {value: '',regex: false}},    		
        { name: t('general.label.description'), data: "description",  orderable: true,  searchable: true, search: {value: '',regex: false}}           
    ];        
    const url = RestService.getBaseURL()+"partner/getPartnerContractList?id="+props.entityId;  
    const urlExcel = RestService.getBaseURL()+"";          
  
  

    const handleCallback  = (id) => {
            props.parentCallback(id);                   
    };
  
         
   
        return (
          
            <DataTableX
                url={url}  
                urlExcel={urlExcel}  
                tableName={tableName}
                columns={columns}   
                columnsData={columnsData}
                parentCallback={handleCallback}
                modalShow={props.modalShow}
                exportShow={false}
            />
          
        );
   

 
};


export default ContractDatatable;

